import ObjektService from '@/services/ObjektService'

const state = {
  item: {},
  loading: false,
  saving: false
}

const getters = {
  item: state => state.item,
  loading: state => !!state.loading,
  saving: state => !!state.saving
}

const actions = {
  get: ({ commit, dispatch }, Objektid) => {
    return new Promise((resolve, reject) => {
      commit('get', Objektid)

      if (state.item !== {} && state.item.Objektid === Objektid) {
        commit('get_success', state.item)
        resolve(state.item)
      } else {
        ObjektService.getObjektKonsult(Objektid)
          .then((response) => {
            commit('get_success', response.data)
            resolve(response)
          })
          .catch((error) => {
            commit('get_failure')
            reject(error)
          })
      }
    })
  },
  save: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit('save', payload)

      let Objektid = payload.Objektid

      ObjektService.saveObjektKonsult(Objektid, payload)
        .then((response) => {
          commit('save_success', response.data)
          resolve(response)
        })
        .catch((error) => {
          commit('save_failure')
          reject(error)
        })
    })
  }
}

const mutations = {
  /** Item methods follow */
  get: (state, id) => {
    state.loading = true
  },
  get_success: (state, data) => {
    console.log('Get success', data)
    state.loading = false
    state.item = data
  },
  get_failure: (state) => {
    state.loading = false
    state.item = {}
  },
  save: (state, payload) => {
    state.saving = true
  },
  save_success: (state, data) => {
    state.saving = false
    state.item = data
  },
  save_failure: (state) => {
    state.saving = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/objektkonsult.js